import { TrainingRecordViewUser } from '@client/components/compliance/training/training-record-view-user';
import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/training/user/$userId')({
    params: {
        parse({ userId }) {
            return {
                userId: BigInt(userId),
            };
        },
    },
    staticData: { ui: { widthVariant: 'default' } },
    beforeLoad({ context: { trpcUtils }, params }): ShareableRouteContext {
        async function title() {
            const user = await trpcUtils.user.getUserForDisplay.ensureData({ id: params.userId, orgId: params.orgId });
            return user?.fullName || '';
        }

        return { breadcrumb: { title } };
    },
    component: TrainingRecordViewUser,
});
